import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Link, Navigate } from 'react-router-dom'
import { compose } from 'redux'
import Swal from 'sweetalert2'
import { apiFetchQuestionnaire, apiFetchQuestionnaireVersion, apiQuestionnaireCreate, apiQuestionnaireCreateVersion, apiQuestionnairePublish, apiQuestionnaireUpdate } from '../../../api/Questionnaire'
import { cloneObject, scrollToElement } from '../../../utils'
import { industryItems } from '../../../utils/StaticTexts'
import Button from '../../Common/Button'
import Page403 from '../../Common/ErrorPage/Page403'
import InputValidator from '../../Common/InputValidator'
import CustomNotificationManager from '../../Common/CustomNotificationManager'
import Loading from '../../Common/Loading'
import { actionAttributes } from './Helpers/ActionsAttributes'
import { changesChecker } from './Helpers/ChangesChecker'
import { denormalizeFromAPI, denormalizeQuestionnaireFromAPI, denormalizeToAPI } from './Helpers/Denormalizer'
import { validate } from './Helpers/Validator'
import './QuestionnaireForm.scss'
import { filteredQuestions } from './Questions/Helpers/Filter' 
import { toggleInvalidAccordion } from './Questions/Helpers/Utils'
import QuestionnaireQuestionsFilters from './Questions/QuestionnaireQuestionsFilters'
import QuestionnaireQuestionsList from './Questions/QuestionnaireQuestionsList'
import withRouter from '../../../private-routers/withRouter'

class QuestionnaireForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = this.defaultState

    this.updateQuestionsList = this.updateQuestionsList.bind(this)
    this.updateQuestion = this.updateQuestion.bind(this)
    this.filterQuestions = this.filterQuestions.bind(this)
    this.toggleAccordion = this.toggleAccordion.bind(this)
  }

  get methods() {
    return {
      createNewDraftQuestionnaire: this.createNewDraftQuestionnaire.bind(this),
      createNewQuestionnaireAndPublish: this.createNewQuestionnaireAndPublish.bind(this),
      createNewVersionAndPublish: this.createNewVersionAndPublish.bind(this),
      updateDraft: this.updateDraft.bind(this),
      publish: this.publish.bind(this)
    }
  }

  get defaultState() {
    return {
      isLoading: false,
      isSaving: false,
      originalState: {},
      questionsAccordion: {},
      errors: {},
      isEditMode: false,
      description: '',
      industry: '',
      deletedQuestions: [],
      questions: [],
      allQuestions: [],
      title: '',
      state: '',
      version: '',
      NavigateToDashboard: false,
      type: 'DATA_CONTROLLER_DPIA',
    }
  }

  get urlParams() {
    return {
      questionnaireId: this.props.params.questionnaireId,
      versionId: this.props.params.versionId
    }
  }

  get disableInput() {
    return this.state.isEditMode || this.state.state === 'PUBLISHED'
  }

  get disabledButton() {
    return this.state.state === 'PUBLISHED' || this.state.isSaving
  }

  componentDidMount() {
    window.scrollTo(0, 0)

    const { questionnaireId, versionId } = this.urlParams
    if (questionnaireId) {
      this.setState({ isLoading: true, isEditMode: true })
      this.fetchQuestionnaire(questionnaireId)
      this.fetchQuestionnaireVersion(questionnaireId, versionId)
    }
  }

  componentWillUnmount() {
    this.setState(this.defaultState)
  }

  fetchQuestionnaire(questionnaireId) {
    apiFetchQuestionnaire(questionnaireId)
      .then((response) => {
        const questionnaire = denormalizeQuestionnaireFromAPI(response.data)
        const values = { ...this.state, ...questionnaire }
        const { originalState, ...initialValues } = values

        this.setState({ ...this.state, ...questionnaire, originalState: cloneObject(initialValues) })
      })
  }

  fetchQuestionnaireVersion(questionnaireId, versionId) {
    apiFetchQuestionnaireVersion(questionnaireId, versionId)
      .then((response) => {
        const questionnaire = denormalizeFromAPI(response.data)
        const values = {
          ...this.state,
          questions: questionnaire.questions,
          allQuestions: questionnaire.questions,
          state: questionnaire.state,
          version: questionnaire.version
        }
        const { originalState, ...initialValues } = values

        this.setState({ ...values, originalState: cloneObject(initialValues), isLoading: false })
      })
    
  }

  updateValue(event, field) {
    this.setState({
      [field]: event.target.value
    })
  }

  alertAttributes(data, questionnaire, action) {
    let hasChanges = false
    // Needs to check these changes just if isEditMode is true
    if (this.state.isEditMode) {
      const originalData = denormalizeToAPI(this.state.originalState)
      hasChanges = changesChecker(data, originalData)
    }
    return actionAttributes(questionnaire, hasChanges, action, this.methods)
  }

  buttonClicked(event, action) {
    event.preventDefault()

    // check if is a publish state trying to save a draft
    if (this.state.state === 'PUBLISHED' && action === 'draft') return

    const questionnaire = validate(this.state)
    this.setState({ ...questionnaire }, () => {
      if (questionnaire.isValid) {
        const data = denormalizeToAPI(this.state)
        const nextAction = this.alertAttributes(data, questionnaire, action)
        const swalQuestionnaire = Swal.mixin({
          // confirmButtonClass: 'btn btn-success',
          // cancelButtonClass: 'btn btn-danger',
          buttonsStyling: false,
        })

        swalQuestionnaire.fire({
          text: nextAction.title,
          //type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result) => {
          if (result.value && nextAction.method) {
            CustomNotificationManager.success(`${ data.title } saved successfully`, `Saved successfully`)
            this.setState({ isSaving: true })
            nextAction.method(data)
          }
        })  
      } else {
        const questionsAccordion = toggleInvalidAccordion(this.state.questions)
        this.setState({ questionsAccordion, isSaving: false }, () => {
          scrollToElement('.errorMessages__list, .inputValidator__invalidWrapper')
        })
      }
    })
  }

  createNewQuestionnaireAndPublish(data) {
    apiQuestionnaireCreate(data)
      .then((response) => {
        const questionnaireId = response.data[0]
        const versionId = response.data[1]
        this.publish(true, questionnaireId, versionId)
      })
      .catch((e) => {
        this.setState({ isSaving: false })
      })

  }

  createNewDraftQuestionnaire(data) {
    apiQuestionnaireCreate(data)
      .then((response) => {
        this.setState({ NavigateToDashboard: true, isSaving: false })
      })
      .catch((e) => {
        this.setState({ isSaving: false })
      })
  }

  updateDraft(data) {
    const { questionnaireId, versionId } = this.urlParams

    apiQuestionnaireUpdate(data, questionnaireId, versionId)
      .then((response) => {
        this.setState({ NavigateToDashboard: true, isSaving: false })
      })
      .catch((e) => {
        this.setState({ isSaving: false })
      })
  }

  createNewVersionAndPublish() {
    const questionnaireId = this.props.params.questionnaireId
    const data = denormalizeToAPI(this.state)
    Object.assign(data, { parentVersion: this.state.version })

    apiQuestionnaireCreateVersion(data, questionnaireId)
      .then((response) => {
        const versionId = response.data
        this.publish(true, questionnaireId, versionId)
      })
      .catch((e) => {
        if (e?.response?.data === 'QUESTIONNAIRE_VERSIONS_NO_LIMIT_REACHED') {
          Swal.fire({
            text: 'You cannot publish more than 10 versions',
            type: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#3DD8DB',
            confirmButtonText: 'Ok'
          }).then((result) => {
            CustomNotificationManager.success('Published successfully', 'Success')
          }) 
        }
        this.setState({ isSaving: false })
      })
  }

  publish(NavigateToDashboard, questionnaireId = this.props.params.questionnaireId, versionId=this.props.params.versionId) {
    const data = denormalizeToAPI(this.state)

    apiQuestionnairePublish(data, questionnaireId, versionId)
      .then((response) => {
        this.setState({ NavigateToDashboard, isSaving: false })
      })
      .catch((e) => {
        this.setState({ isSaving: false })
      })
  }

  updateQuestionsList({ questions, deletedQuestions = this.state.deletedQuestions }) {
    this.setState({
      questions,
      deletedQuestions,
      allQuestions: questions
    })
  }

  updateQuestion(index, question, callback) {
    const newQuestions = [...this.state.questions]
    newQuestions[index] = question
    this.setState({
      questions: newQuestions,
      allQuestions: newQuestions
    }, callback)
  }

  filterQuestions(filterAttributes) {
    const params = {
      ...filterAttributes,
      allQuestions: this.state.allQuestions,
      deletedQuestions: this.state.deletedQuestions
    }

    this.setState({
      ...filteredQuestions(params)
    })
  }

  formattedTitle(isEditMode, title, state, version) {
    if (!isEditMode) return 'New PIA/DPIA Questionnaire'
    if (state !== 'DRAFT') return `V${ version } - ${ title }`
    return `(Draft) V${ version } - ${ title }`
  }

  toggleAccordion(index) {
    this.setState({
      questionsAccordion: {
        ...this.state.questionsAccordion,
        [index]: !this.state.questionsAccordion[index]
      }
    })
  }

  render() {
    const {
      questionsAccordion,
      description,
      errors,
      industry,
      isEditMode,
      questions,
      deletedQuestions,
      state,
      title,
      type,
      version,
      NavigateToDashboard,
      isLoading,
      isSaving
    } = this.state

    const { subscription } = this.props

    if (!subscription.unlimitedPlan) {
      return (
        <div className="newQuestionnaire__page">
          <Page403 />
        </div>
      )
    }

    return (
      <div className="newQuestionnaire__page">
        { NavigateToDashboard &&
          <Navigate to="/dpia/questionnaires" />
        }
          <div className="link-back-questionnaires">
              <Link to="/dpia/questionnaires" className="reportDetail-link">Back to questionnaires</Link>
              <span onClick={() => this.props.navigate(-1)} className="pia-questionnaire-link">Back to the pia questionnaire</span>
          </div>

        { isLoading &&
          <div className="newQuestionnaire__loading">
            <Loading />
          </div>
        }

        { !isLoading &&
          <React.Fragment>
            <div className="newQuestionnaire__section">
              <header className="newQuestionnaire__header">
                <h1 className="newQuestionnaire__title">
                  { this.formattedTitle(isEditMode, title, state, version) }
                </h1>
                <div className="newQuestionnaire__submitButtons">
                  { isSaving &&
                    <div className="newQuestionnaire__loading">
                      <Loading />
                    </div>
                  }

                  <div className={ this.disabledButton ? 'newQuestionnaire__disabledButton' : ''}>
                    <Button 
                      theme={ this.disabledButton ? 'gray' : 'green' } 
                      onClick={ (e) => this.buttonClicked(e, 'draft') }>

                      Save Draft
                    </Button>
                  </div>

                  <div>
                    <Button theme="green" onClick={ (e) => this.buttonClicked(e, 'publish') }>
                      Publish
                    </Button>
                  </div>
                </div>
              </header>
              
              <form className="newQuestionnaire__form">
                <div className="newQuestionnaire__formGroup">
                  <div className="newQuestionnaire__errorsList">
                    <InputValidator errors={ errors } field="questions" />
                  </div>

                  <label htmlFor="title" className="newQuestionnaire__requiredField">Title</label>
                  <InputValidator errors={ errors } field="title">
                    <input 
                      id="title"
                      value={ title }
                      disabled={ this.disableInput }
                      onChange={ (e) => this.updateValue(e, 'title') }
                    />
                  </InputValidator>
                </div>

                <div className="newQuestionnaire__formGroup">
                  <label htmlFor="description">Description</label>
                  <textarea 
                    id="description"
                    value={ description }
                    onChange={ (e) => this.updateValue(e, 'description') }
                  />
                </div>

                <div className="newQuestionnaire__formGroup--sideBySide">
                  <div className="newQuestionnaire__formGroup">
                    <label htmlFor="type" className="newQuestionnaire__requiredField">Questionnaire type</label>
                    <select
                      id="type"
                      disabled={ this.disableInput }
                      value={ type }
                      onChange={ (e) => this.updateValue(e, 'type') }
                    >
                      <option value="DATA_CONTROLLER_DPIA">DPIA Controller</option>
                      <option value="DATA_PROCESSOR_DPIA">DPIA Processor</option>
                      <option value="PIA">PIA</option>
                    </select>
                  </div>

                  <div className="newQuestionnaire__formGroup">
                    <label htmlFor="industry">Industry</label>
                    <select 
                      id="industry"
                      value={ industry }
                      onChange={ (e) => this.updateValue(e, 'industry') }
                    >
                      <option value="">-- Select ---</option>
                      {
                        industryItems.map((industry, index) => (
                          <option key={ `industry-${ index }` } value={ industry }>{ industry }</option>
                        ))
                      }
                    </select>
                  </div>
                </div>
              </form>
            </div>

            <QuestionnaireQuestionsFilters
              filterQuestions={ this.filterQuestions }
            />

            {
              <QuestionnaireQuestionsList
                questionsAccordion={ questionsAccordion }
                toggleAccordion={ this.toggleAccordion }
                questionnaireType={ type }
                questions={ questions }
                deletedQuestions={ deletedQuestions }
                updateQuestion={ this.updateQuestion }
                updateQuestionsList={ this.updateQuestionsList }
              />
            }
          </React.Fragment>
        }
      </div>
    )
  }
}

const stateMap = (state) => ({
  subscription: state.subscriptionReducer.subscription
})
QuestionnaireForm = withRouter(QuestionnaireForm)
QuestionnaireForm.propTypes = {
  subscription: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

export default compose(
  connect(stateMap, null),
)(QuestionnaireForm)